import React from 'react';
import { CenterModal, BaseModal } from 'react-spring-modal';
import video from '../assets/Konnect_Project8.mp4';
// import m_video from '../assets/m_Konnect_Project8.mp4'
import m_video from '../assets/0906.mp4';
import { isMobile } from 'react-device-detect';
import { createGlobalStyle } from 'styled-components';
export const OpenAnimationModal = ({
	onClick,
	textData,
	// videoLink = video,
	successImg = '../assets/booldog_image/1.png',
	videomodal,
	setVideoModal,
}) => {
	const openBoxObj = videomodal;

	const videoRef = React.useRef();

	let videoPlay = document.querySelector('.video_view');
	const completeBtnOnClick = () => {
		setVideoModal({ isOpen: false, ...openBoxObj });
		setVideoModal(false);
	};

	function Modalvideo() {
		return (
			<>
				<div
					className={
						window.innerWidth > 1000
							? 'complete_img'
							: 'm_complete_img'
					}
					// style={videomodal.isOpen ? {display : "flex"} : {display : "none"}}
				>
					<img src={videomodal.imgUrl} alt='completeImage' />
					<div
						className={
							window.innerWidth > 1000
								? 'ship_btn3'
								: 'm_ship_btn3'
						}
						onClick={() => {
							completeBtnOnClick();
							onClick();
						}}
					>
						<p>{textData && textData.modal['get PFP']}</p>
					</div>
				</div>
				<video
					onFocus={() => {
						videoPlay.play();
					}}
					className={
						window.innerWidth > 1000 ? 'video_view' : 'm_video_view'
					}
					ref={videoRef}
					webkit-playsinline='true'
					autoPlay
					playsInline
					muted
				>
					{window.innerWidth > 1000 ? (
						<source className='video_src' src={video}></source>
					) : (
						<source className='video_src' src={m_video}></source>
					)}
				</video>
			</>
		);
	}

	return (
		<div style={{ overflow: 'hidden' }}>
			{videomodal.isOpen ? (
				<div
					className={
						window.innerWidth > 1000
							? 'video_modal'
							: 'm_video_modal'
					}
					style={{ display: videomodal ? 'block' : 'none' }}
				>
					{/* <div className='video_modal'  style={{display: videomodal ? 'none' : 'none'}}> */}
					{Modalvideo()}
				</div>
			) : null}
		</div>
	);
};

const GlobalStyle = createGlobalStyle`
    body {
        /* overflow: hidden; */
        /* white-space: pre-wrap; */
    }
`;
